import { Address } from "@/dto/address";
import { localizedPhoneNumber } from "@/components/_localized/localizationUtils";
import Link from "next/link";
import { usePathname } from "next/navigation";

interface MerchantNameAndAddressProps {
  merchantName?: string;
  isSimpleStorefront: boolean;
  isStandaloneGiftCard: boolean;
  merchantAddress: Address;
  merchantPhone: string;
  textRef?: React.RefObject<HTMLParagraphElement | null>;
  isMultiline: boolean;
  showLink?: boolean;
  linkHref: string | object;
}

export const MerchantNameAndAddress = ({
  merchantName = "Default Merchant Name",
  isSimpleStorefront,
  isStandaloneGiftCard,
  merchantAddress,
  merchantPhone,
  textRef,
  isMultiline,
  showLink,
  linkHref,
}: MerchantNameAndAddressProps) => {
  const commonClasses = ["flex", "flex-col"];
  const simpleStoreFrontClasses = !isSimpleStorefront
    ? ["max-h-[33px]"]
    : ["text-center", "sm:text-left"];
  const containerClassNames = [
    "sm:max-h-none",
    ...commonClasses,
    ...simpleStoreFrontClasses,
  ].join(" ");
  const merchantNameClasses = [
    "leading-normal",
    "font-normal",
    "break-all",
    "sm:max-w-none",
    isMultiline ? "text-[18px] sm:text-[32px]" : "text-[22px] sm:text-[32px]",
  ].join(" ");

  const pathname = usePathname();
  const isConfirmationPage: boolean =
    pathname?.includes("/confirmation") || false;

  const merchantInfo = (
    <div className={containerClassNames}>
      <p ref={textRef} className={merchantNameClasses}>
        {merchantName}
      </p>
      {!isConfirmationPage && (isSimpleStorefront || isStandaloneGiftCard) && (
        <div>
          <p className="text-[15px]">
            {Object.values(merchantAddress).filter(Boolean).join(", ")}
          </p>
          <p className="text-[15px]">{localizedPhoneNumber(merchantPhone)}</p>
        </div>
      )}
    </div>
  );

  if (showLink) {
    return <Link href={linkHref}>{merchantInfo}</Link>;
  }
  return merchantInfo;
};
